import type { ReactNode } from 'react';

/**
 * Places a block background behind the block's own content.
 *
 * The negative z-index is what puts it under the content, and it only works
 * while the positioned ancestor establishes a stacking context (`isolate`) —
 * without one the layer would paint below that ancestor's background colour
 * instead of above it. Clipping lives here rather than on the ancestor so that
 * content outgrowing a fixed `aspect-*` box still overflows as it would have
 * without a background.
 */
export const BackgroundLayer: React.FC<{ children: ReactNode }> = ({
  children,
}) => (
  <div className="absolute inset-0 -z-1 overflow-hidden rounded-[inherit]">
    {children}
  </div>
);
